import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(private http: HttpClient, private logger: NGXLogger) {
    this.load();
  }

  private configUrl = `assets/app.config.json`;
  static configSettings: any = null;

  get settings() {
    return AppService.configSettings;
  }

  public load(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(this.configUrl).subscribe((response: any) => {
        AppService.configSettings = response;
        this.logger.updateConfig({
          serverLoggingUrl: `${AppService.configSettings.webApi}/logging/api`,
          level: NgxLoggerLevel.TRACE,
          serverLogLevel: NgxLoggerLevel.TRACE,
          enableSourceMaps: true
        });
        resolve(true);
      });
    });
  }

}
